import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function () {
      var title = this.htmlTitle;
      // html2Canvas(document.querySelector('#pdfDom'), { //这是在界面上设置一个id
      //只下载id为pdfDom的内容
      html2canvas(document.querySelector("#pdfDom"), {
        dpi: 900, //解决生产图片模糊
      }).then(function (canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;

        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        // 第一个参数： l：横向  p：纵向
        // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
        //   第三个参数：生成格式 默认a4格式
        let pdf = new jsPDF("p", "pt", "a4");
        pdf.addImage(
          canvas.toDataURL("image/jpeg", 1.0),
          "JPEG",
          0,
          0,
          imgWidth,
          imgHeight
        );
        pdf.save(title + ".pdf");
      });
    };
  },
};
